import { animate, onScroll, utils } from 'animejs';

export default () => {
  const numberBlocks = document.querySelectorAll('[data-animated-numbers]');
  
  numberBlocks.forEach((block) => {
    const numberElements = block.querySelectorAll('[data-count]');
    
    numberElements.forEach((element) => {
      //const targetValue = parseInt(element.dataset.count, 10);

      
      // Start from 0
      // element.innerHTML = '0';
      
      let animation = animate(element, {
        innerHTML: [0, element.getAttribute('data-count')],
        easing: 'easeInOutSine',
        modifier: (val) => {
          return val.toLocaleString('en-US', { maximumFractionDigits: 0 });
        },
        duration: 3000,
        autoplay: onScroll({
          enter: 'bottom+=100vh',
          leave: 'top+=10vh',
          sync: 'play reset play reset',
          repeat: true,
        }),
      });
    });
    
    // Handle icon animations for teal grid style
    const iconElements = block.querySelectorAll('.animated-number-grid-item__icon');
    iconElements.forEach((element) => {
      animate(element, {
        opacity: [0, 1],
        translateY: ['20px', '0px'],
        easing: 'easeOutQuart',
        duration: 1000,
        autoplay: onScroll({
          enter: 'bottom+=100vh',
          leave: 'top+=10vh',
          sync: 'play reset play reset',
          repeat: true,
        }),
      });
    });
  });
};
